// Mock data for GoBru Taxi Service

export const translations = {
  en: {
    nav: {
      home: 'Home',
      whoWeAre: 'Who Are We',
      contact: 'Contact Us'
    },
    home: {
      heroTitle: 'GoBru – Reliable Taxi Service in Belgium',
      heroDescription: 'GoBru offers safe, comfortable, and punctual taxi rides for everyday travel, airport transfers, and business trips. With professional drivers and clean vehicles, we make every ride smooth and stress-free.',
      bookRide: 'Book a Ride',
      contactUs: 'Contact Us',
      servicesTitle: 'Our Services',
      services: [
        { title: 'City Rides', description: 'Quick and comfortable rides within the city' },
        { title: 'Airport Transfers', description: 'Reliable transportation to and from airports' },
        { title: 'Business & Private Transport', description: 'Professional service for all your needs' },
        { title: 'On-time Pickup', description: 'We value your time and ensure punctuality' }
      ]
    },
    whoWeAre: {
      title: 'Who Are We',
      description: 'GoBru is a local taxi service focused on reliability, comfort, and customer satisfaction. We understand the importance of being on time and traveling safely, whether it\'s a short city trip or a long-distance ride.',
      driverDescription: 'Our drivers are professional, experienced, and committed to providing a pleasant experience for every passenger. Our vehicles are clean, modern, and well-maintained to ensure maximum comfort.',
      whyChooseTitle: 'Why Choose GoBru',
      reasons: [
        'Professional and friendly drivers',
        'Clean and comfortable vehicles',
        'Reliable and punctual service',
        'Transparent and fair pricing',
        'Available for private and business clients'
      ]
    },
    contact: {
      title: 'Contact GoBru',
      directContact: 'Direct Contact Options',
      reachUs: 'You can reach us easily through:',
      whatsapp: 'WhatsApp',
      phone: 'Phone',
      email: 'Email',
      requestOfferTitle: 'Request a Price Offer',
      form: {
        fullName: 'Full Name',
        phoneNumber: 'Phone Number',
        email: 'Email Address',
        pickupLocation: 'Pickup Location',
        destination: 'Destination',
        dateTime: 'Date & Time',
        message: 'Message (optional)',
        submit: 'Send Request',
        successMessage: 'Thank you for your request. We will contact you shortly.'
      }
    },
    footer: {
      allRights: 'All rights reserved'
    }
  },
  nl: {
    nav: {
      home: 'Home',
      whoWeAre: 'Wie Zijn Wij',
      contact: 'Contact'
    },
    home: {
      heroTitle: 'GoBru – Betrouwbare Taxidienst in België',
      heroDescription: 'GoBru biedt veilige, comfortabele en stipte taxiritten voor dagelijks vervoer, luchthaventransfers en zakenreizen. Met professionele chauffeurs en schone voertuigen maken wij elke rit soepel en stressvrij.',
      bookRide: 'Boek een Rit',
      contactUs: 'Contacteer Ons',
      servicesTitle: 'Onze Diensten',
      services: [
        { title: 'Stadsritten', description: 'Snelle en comfortabele ritten binnen de stad' },
        { title: 'Luchthavntransfers', description: 'Betrouwbaar vervoer van en naar luchthavens' },
        { title: 'Zakelijk & Privévervoer', description: 'Professionele service voor al uw behoeften' },
        { title: 'Stipte Ophaling', description: 'Wij waarderen uw tijd en garanderen punctualiteit' }
      ]
    },
    whoWeAre: {
      title: 'Wie Zijn Wij',
      description: 'GoBru is een lokale taxidienst gericht op betrouwbaarheid, comfort en klanttevredenheid. Wij begrijpen het belang van op tijd zijn en veilig reizen, of het nu een korte stadsrit of een lange afstand is.',
      driverDescription: 'Onze chauffeurs zijn professioneel, ervaren en toegewijd om elke passagier een aangename ervaring te bieden. Onze voertuigen zijn schoon, modern en goed onderhouden om maximaal comfort te garanderen.',
      whyChooseTitle: 'Waarom Kiezen voor GoBru',
      reasons: [
        'Professionele en vriendelijke chauffeurs',
        'Schone en comfortabele voertuigen',
        'Betrouwbare en stipte service',
        'Transparante en eerlijke prijzen',
        'Beschikbaar voor privé- en zakelijke klanten'
      ]
    },
    contact: {
      title: 'Contact GoBru',
      directContact: 'Directe Contactmogelijkheden',
      reachUs: 'U kunt ons eenvoudig bereiken via:',
      whatsapp: 'WhatsApp',
      phone: 'Telefoon',
      email: 'E-mail',
      requestOfferTitle: 'Vraag een Prijsofferte Aan',
      form: {
        fullName: 'Volledige Naam',
        phoneNumber: 'Telefoonnummer',
        email: 'E-mailadres',
        pickupLocation: 'Ophaallocatie',
        destination: 'Bestemming',
        dateTime: 'Datum & Tijd',
        message: 'Bericht (optioneel)',
        submit: 'Verzend Aanvraag',
        successMessage: 'Bedankt voor uw aanvraag. Wij nemen spoedig contact met u op.'
      }
    },
    footer: {
      allRights: 'Alle rechten voorbehouden'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      whoWeAre: 'Qui Sommes-Nous',
      contact: 'Contact'
    },
    home: {
      heroTitle: 'GoBru – Service de Taxi Fiable en Belgique',
      heroDescription: 'GoBru propose des trajets en taxi sûrs, confortables et ponctuels pour les déplacements quotidiens, les transferts aéroportuaires et les voyages d\'affaires. Avec des chauffeurs professionnels et des véhicules propres, nous rendons chaque trajet fluide et sans stress.',
      bookRide: 'Réserver un Trajet',
      contactUs: 'Contactez-Nous',
      servicesTitle: 'Nos Services',
      services: [
        { title: 'Trajets en Ville', description: 'Trajets rapides et confortables dans la ville' },
        { title: 'Transferts Aéroport', description: 'Transport fiable vers et depuis les aéroports' },
        { title: 'Transport Professionnel & Privé', description: 'Service professionnel pour tous vos besoins' },
        { title: 'Ramassage à l\'Heure', description: 'Nous valorisons votre temps et assurons la ponctualité' }
      ]
    },
    whoWeAre: {
      title: 'Qui Sommes-Nous',
      description: 'GoBru est un service de taxi local axé sur la fiabilité, le confort et la satisfaction client. Nous comprenons l\'importance d\'être à l\'heure et de voyager en toute sécurité, qu\'il s\'agisse d\'un court trajet en ville ou d\'un long trajet.',
      driverDescription: 'Nos chauffeurs sont professionnels, expérimentés et engagés à offrir une expérience agréable à chaque passager. Nos véhicules sont propres, modernes et bien entretenus pour assurer un confort maximal.',
      whyChooseTitle: 'Pourquoi Choisir GoBru',
      reasons: [
        'Chauffeurs professionnels et amicaux',
        'Véhicules propres et confortables',
        'Service fiable et ponctuel',
        'Tarification transparente et équitable',
        'Disponible pour les clients privés et professionnels'
      ]
    },
    contact: {
      title: 'Contact GoBru',
      directContact: 'Options de Contact Direct',
      reachUs: 'Vous pouvez nous joindre facilement par:',
      whatsapp: 'WhatsApp',
      phone: 'Téléphone',
      email: 'E-mail',
      requestOfferTitle: 'Demander un Devis',
      form: {
        fullName: 'Nom Complet',
        phoneNumber: 'Numéro de Téléphone',
        email: 'Adresse E-mail',
        pickupLocation: 'Lieu de Prise en Charge',
        destination: 'Destination',
        dateTime: 'Date & Heure',
        message: 'Message (optionnel)',
        submit: 'Envoyer la Demande',
        successMessage: 'Merci pour votre demande. Nous vous contacterons sous peu.'
      }
    },
    footer: {
      allRights: 'Tous droits réservés'
    }
  }
};

export const contactInfo = {
  whatsapp: '+32 470 49 65 26',
  phone: '+32 470 49 65 26',
  email: 'info@gobru.be'
};

export const images = {
  heroImage: 'https://www.elektrischeauto.be/src/Frontend/Files/Cache/photoswipe_max_size/src/Frontend/Files/MediaLibrary/02/model3-52.webp',
  taxiCar: 'https://scene7.toyota.eu/is/image/toyotaeurope/COR0004b_25_WEB:Large-Landscape?ts=0&resMode=sharp2&op_usm=1.75,0.3,2,0&fmt=png-alpha',//'https://www.jowua-life.com/cdn/shop/articles/tesla_model_y_l_launch_in_north_america_projection-8082668.png?v=1758044717',
  taxiCar2:'https://www.jowua-life.com/cdn/shop/articles/tesla_model_y_l_launch_in_north_america_projection-8082668.png?v=1758044717',
  professionalCab: 'https://api.brusselstimes.com/wp-content/uploads/2022/10/4d529d2a-belgaimage-2147558-1024x683.jpeg'
};